import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectUser } from '../../../redux/userSlice'
import { hasUserPermission } from '../../../utils/permissionHelper'
import { blockPermissions } from './blockChangeHelpers'

// Reads carry spoofUserID, so what is shown follows the spoofed user; useRequest leaves it off writes, which
// would run as the real admin. Editing is therefore off while spoofing.
export function useLeadFunnelBlocksPermissions() {
  const user = useSelector(selectUser)
  const navi = useNavigate()
  const activeUser = user.spoofed_user?.user_permission_options
    ? user.spoofed_user
    : user.data
  const activePermissions = activeUser?.user_permission_options

  useEffect(() => {
    if (user.status === 'succeeded' && user.data.user_permission_options) {
      if (!hasUserPermission(activePermissions, 'lead_funnel_block_read')) {
        navi('/403')
      }
    }
  }, [user, navi, activePermissions])

  return {
    permissions: blockPermissions(activePermissions),
    currentUserId: activeUser?.id ?? null,
    isSpoofing: Boolean(user.spoofed_user?.id),
  }
}
